import { createSlice } from '@reduxjs/toolkit'
import { postCustomerList, postCustomerCount} from "./thunks"
import { logOut } from '../authentication/authenticationSlice';

const initialState= {
  list: {

    pageIndex: 0,
totalRecords: 50,
totalPages: 1,
hasPreviousPage: false,
hasNextPage: false,
elements: []
  },
  loading: "idle",
  loadingCount: "idle",
  error: null }

const customerSlice = createSlice({
  name: 'customers',
  initialState,
  reducers: {
    clearCustomerError:(state)=>{
      state.error= null
    },
    setCustomerFilters:(state, action)=>{
      state.filters= action.payload
    }
  },
  extraReducers: {
    [postCustomerList.pending]: (state) => {
        state.loading = "loading";
        state.error = null
      },
    [postCustomerList.fulfilled]: (state, action) => {
    state.loading = "succeeded";
    state.list.elements = action.payload.elements;
    },
    [postCustomerList.rejected]: (state, action) => {
        state.loading = "failed";
        state.error = action.error.message
    },
    [postCustomerCount.pending]: (state) => {
      state.loadingCount = "loading"; 
      state.error = null
    },
    [postCustomerCount.fulfilled]: (state, action) => {
      state.loadingCount = "succeeded";
      state.list.pageIndex = action.payload.pageIndex;
      state.list.totalRecords = action.payload.totalRecords;
      state.list.totalPages = action.payload.totalPages;
      state.list.hasPreviousPage = action.payload.hasPreviousPage;
      state.list.hasNextPage =action.payload.hasNextPage;

    },
    [postCustomerCount.rejected]: (state, action) => {
      state.loadingCount = "failed"; 
      state.error = action.error.message
    },
  },
  [logOut]: (state)=> initialState
})

export const {clearCustomerError, setCustomerFilters} = customerSlice.actions;

export default customerSlice.reducer
